module.exports = __webpack_public_path__ + "static/img/money.22fca50.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/dataBrain/money.png
// module id = 5doV
// module chunks = 1